export default __webpack_public_path__ + "1138b34c610bbacf493ba7e442be6dcf.png";